<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M21.3149 11.2555C21.3149 10.628 22.0736 10.3138 22.5173 10.7575L24.8364 13.0765L27.1556 15.3956C27.5993 15.8392 27.285 16.5978 26.6576 16.5978H22.0192C21.6303 16.5978 21.3149 16.2825 21.3149 15.8936V11.2555Z"
    fill="currentColor"
  />
  <path
    d="M19.8048 10.5498V17.2296C19.8048 17.7158 20.199 18.1099 20.6852 18.1099H27.3648V27.9379C27.3648 28.7729 26.6879 29.4499 25.8528 29.4499H14.5121C13.677 29.4499 13 28.7729 13 27.9379V12.0619C13 11.2268 13.677 10.5499 14.5121 10.5499L19.8048 10.5498Z"
    fill="currentColor"
  />
</svg>
